<div class="page-header">
  <app-page-title></app-page-title>
</div>

<div class="card shadow-sm border-0 mb-4">
  <div class="card-header py-3 bg-white">
    <form class="d-flex align-items-center justify-content-between gap-2 flex-wrap" (ngSubmit)="search()">
      <div class="d-flex align-items-center gap-2">
        <div class="input-group input-group-sm master-search-group">
          <input type="text" class="form-control" name="term"
                 placeholder="กรอกข้อมูลสำหรับค้นหา"
                 [ngModel]="term()"
                 (ngModelChange)="term.set($event)"/>
          <button class="btn btn-default" type="submit">
            <i class="bi bi-search"></i>
          </button>
        </div>
        <button type="button" class="btn btn-sm btn-default" (click)="reset()">ล้าง</button>
      </div>

      <div class="d-flex align-items-center gap-2">
        <gt-ng-datepicker name="dateStart" size="sm" placeholder="วันที่เริ่มต้น"
                          [ngModel]="dateStart()" (ngModelChange)="dateStart.set($event)"/>

        <span class="text-body-secondary small">ถึง</span>

        <gt-ng-datepicker name="dateEnd" size="sm" placeholder="วันที่สิ้นสุด"
                          [ngModel]="dateEnd()" (ngModelChange)="dateEnd.set($event)"/>

        <select class="form-select form-select-sm filter-select"
                name="operatorGroup"
                [ngModel]="operatorGroup()"
                (ngModelChange)="operatorGroup.set($event); search()">
          <option value="">- ประเภทผู้ดำเนินการ -</option>
          <option value="USER">ผู้ใช้งาน</option>
          <option value="API">API</option>
        </select>
      </div>
    </form>
  </div>

  <div class="card-subheader px-3 py-2 border-bottom bg-white d-flex align-items-center justify-content-between gap-2 flex-wrap">
    <div class="d-flex align-items-center gap-2">
      <span class="text-body-secondary small">Show</span>
      <app-pagesize-select size="sm" [value]="pageData().page.size"
                           (valueChange)="pageData().page.size = $event; search()"/>
      <span class="text-body-secondary small">entries</span>
    </div>
    <div class="d-flex align-items-center gap-2">
      @if (selectedIds().size > 0) {
        <span class="text-body-secondary small">เลือกแล้ว {{ selectedIds().size }} รายการ</span>
      }
      <button type="button" class="btn btn-sm btn-primary" (click)="openKeepModal(keepModal)">
        <i class="bi bi-bookmark-check me-1"></i>เก็บรักษาข้อมูลไว้
      </button>
    </div>
  </div>

  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table caption-top table-hover mb-0">
        <thead class="bg-light">
          <tr>
            <th nowrap class="text-center" style="width: 36px;">
              <input type="checkbox" class="form-check-input table-checkbox"
                     [checked]="isAllSelected()"
                     (change)="toggleSelectAll()"/>
            </th>
            <th nowrap class="text-center">No.</th>
            <th nowrap>วันเวลาที่ดำเนินการ</th>
            <th nowrap>ชื่อผู้ดำเนินการ</th>
            <th nowrap>รายละเอียด</th>
            <th nowrap>IP address</th>
            <th nowrap>ประเภทผู้ดำเนินการ</th>
            <th nowrap class="text-center">จำนวนวัน</th>
          </tr>
        </thead>
        <tbody>
          @if (pageData()?.content?.length === 0) {
            <tr>
              <td colspan="8" class="text-center py-4 text-body-secondary">- ไม่มีข้อมูล -</td>
            </tr>
          } @else {
            @for (row of pageData()?.content; track row.id; let i = $index) {
              <tr [class.table-active]="isItemSelected(row.id)">
                <td class="text-center">
                  <input type="checkbox" class="form-check-input table-checkbox"
                         [checked]="isItemSelected(row.id)"
                         (change)="toggleSelectItem(row.id)"/>
                </td>
                <td class="text-center">{{ (pageData().page?.size * pageData().page?.number) + (i + 1) }}</td>
                <td nowrap>
                  <div>{{ row.created | thaidatetime }}</div>
                  @if (row.keep) {
                    <a href="javascript:void(0)" class="keep-link small"
                       title="ดูข้อมูลการเก็บรักษา"
                       (click)="openKeepDetailModal(keepModal, row)">(เก็บรักษาข้อมูลไว้)</a>
                  }
                </td>
                <td nowrap>{{ row.createdByName || 'ผู้เยี่ยมชม' }}</td>
                <td style="max-width: 300px;">
                  <span class="text-truncate d-inline-block" style="max-width: 300px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                        [title]="row.detail || ''">
                    {{ row.detail || '-' }}
                  </span>
                </td>
                <td>{{ row.ipAddress || '-' }}</td>
                <td>{{ operatorTypeLabel(row) }}</td>
                <td class="text-center">{{ row.countDay ?? 0 }} วัน</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-footer bg-white d-flex justify-content-between align-items-center">
    <span class="text-body-secondary small">Total {{ pageData().page?.totalElements ?? 0 }} records</span>
    <ngb-pagination [collectionSize]="pageData().page.totalElements"
                    [page]="pageData().page.number + 1"
                    [pageSize]="pageData().page.size"
                    [maxSize]="5"
                    [rotate]="true"
                    [boundaryLinks]="true"
                    (pageChange)="search($event)">
    </ngb-pagination>
  </div>
</div>

<div class="alert alert-info alert-dismissible fade show mt-3" role="alert">
  <strong>หมายเหตุ</strong><br/>
  ข้อมูล Log จะถูกเก็บไว้นานสูงสุด {{ retentionDays() }} วัน (ยกเว้นรายการที่เก็บรักษาข้อมูลไว้)
  <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
</div>

<!-- modal เก็บรักษาข้อมูล -->
<ng-template #keepModal let-modal>
  <div class="modal-header" ngbAutofocus>
    <h6 class="modal-title">เก็บรักษาข้อมูล</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.close()"></button>
  </div>
  <div class="modal-body">
    @if (keepMode() === 'view') {
      <div class="d-flex justify-content-end mb-3">
        <button type="button" class="btn btn-sm btn-warning" [disabled]="keepSaving()" (click)="cancelKeep()">
          ยกเลิกการเก็บรักษาข้อมูล
        </button>
      </div>
    } @else {
      <div class="text-body-secondary small mb-3">รายการที่เลือก {{ selectedIds().size }} รายการ</div>
    }

    <div class="row mb-3 align-items-start">
      <label class="col-sm-3 col-form-label col-form-label-sm text-sm-end" for="keepDetail">
        เหตุผล @if (keepMode() === 'create') {<span class="text-danger">*</span>}
      </label>
      <div class="col-sm-8">
        <textarea id="keepDetail" name="keepDetail" rows="3" class="form-control form-control-sm"
                  [class.is-invalid]="keepMode() === 'create' && keepSubmitted() && !keepDetail().trim()"
                  [disabled]="keepMode() === 'view'"
                  [ngModel]="keepDetail()" (ngModelChange)="keepDetail.set($event)"></textarea>
        @if (keepMode() === 'create' && keepSubmitted() && !keepDetail().trim()) {
          <div class="invalid-feedback">กรุณาระบุเหตุผล</div>
        }
      </div>
    </div>

    <div class="row mb-3 align-items-center">
      <label class="col-sm-3 col-form-label col-form-label-sm text-sm-end">ผู้บันทึก</label>
      <div class="col-sm-8">
        <input type="text" class="form-control form-control-sm" [value]="keepByName() || '-'" disabled/>
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 col-form-label col-form-label-sm text-sm-end">วันที่บันทึก</label>
      <div class="col-sm-8">
        <input type="text" class="form-control form-control-sm" [value]="keepAt() ? (keepAt() | thaidatetime) : '-'" disabled/>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    @if (keepMode() === 'create') {
      <button type="button" class="btn btn-primary" [disabled]="keepSaving()" (click)="saveKeep()">
        @if (keepSaving()) {<span class="spinner-border spinner-border-sm me-1"></span>}
        บันทึก
      </button>
    }
    <button type="button" class="btn btn-default" (click)="modal.close()">ยกเลิก</button>
  </div>
</ng-template>
